<template>
  <v-container fluid class="pa-0" v-if="permisoVista('optimizacion','r')">
    <div v-if="loading">
      <div
          class="d-flex justify-center align-center flex-column"
          style="min-height: 80vh"
      >
        <v-progress-circular
            :size="90"
            :width="6"
            color="primary"
            indeterminate
        ></v-progress-circular>
        <p class="text-center text-h4">Cargando</p>
      </div>
    </div>

    <div v-if="!loading">
      <div
          style="display: flex; flex-direction: column; justify-items: center; align-items: center; max-width: 100%;"
      >
        <div
            style="width: 100%; display: flex; flex-direction: column;"
        >
          <h3>
            Selecciona un molde para visualizar la optimización de producción
          </h3>
          <v-autocomplete
              v-model="selectedMolde"
              :items="filteredMoldes"
              :item-text="getItemText"
              item-value="idMolde"
              :search-input.sync="search"
              placeholder="Buscar por código, nombre o ID de molde"
              return-object
              class="autocomplete-input"
          >
            <template v-slot:selection="data">
              <v-chip
                  :input-value="data.selected"
                  color="primary"
                  text-color="white"
                  close
                  @click:close="data.parent.selectItem(null)"
                  @input="data.parent.selectItem(null)"
              >
                {{ data.item.codigo || data.item.nombre }}
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <template v-if="typeof item === 'object' && item !== null">
                  <v-list-item-title>{{ item.codigo || item.nombre }}</v-list-item-title>
                </template>
                <template v-else>
                  {{ item }}
                </template>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>

        <div
            v-if="areasProduccion.length === 0"
            style="width: 100%; display: flex; justify-items: center; margin-left: auto; margin-right: auto;"
        >
          <div
              class="text-center d-flex flex-column align-center justify-center"
              style="width: 100%;"
          >
            <div>
              <v-icon color="yellow darken-2" style="font-size: 6.25rem;">
                mdi-alert
              </v-icon>
            </div>
            <p class="text-center text-h5">
              No hay datos que mostrar, al parecer aún no se ha realizado ninguna
              simulación.
            </p>
          </div>
        </div>
        <div
            v-else
            class="d-flex overflow-x-auto overflow-y-auto"
            style="max-width: 100%;"
        >
          <div
              v-for="(area, idxArea) in areasProduccion"
              :key="`area-${idxArea}`"
              class="pa-3 mr-5"
              :style="area.activo?'background-color: rgba(255, 0, 0, 0.5); border-radius: 0.5rem;' :'background-color: rgba(207, 216, 220, 0.5); border-radius: 0.5rem;'"
          >
            <div class="mb-3 d-flex align-center justify-space-between">
              <div style="width: 24px"><!-- no eliminar --></div>
              <p class="mb-0 text-center text-h5 font-weight-bold">
                {{ area.nombre }}
              </p>
              <div v-if="area.lineas.length > 1 && permisoVista('optimizacion','u')">
                <v-tooltip
                    v-if="!area.modoEditar"
                    bottom
                    color="black"
                    class="white--text"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                        :disabled="area.disabled || !!area.savingOrden"
                        @click="setModoEditarArea(area)"
                    >mdi-pencil
                    </v-icon>
                  </template>
                  <span class="white--text">Editar</span>
                </v-tooltip>
                <template v-if="!!area.modoEditar">
                  <v-tooltip
                      v-if="permisoVista('optimizacion','u')"
                      bottom
                      color="black"
                      class="white--text"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!!area.savingOrden"
                          @click="saveNuevoOrdenArea(area)"
                      >mdi-content-save
                      </v-icon>
                    </template>
                    <span class="white--text">Guardar</span>
                  </v-tooltip>
                  <v-tooltip
                      bottom
                      color="black"
                      class="white--text"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!!area.savingOrden"
                          @click="cancelModoEditarArea(area)"
                      >mdi-cancel
                      </v-icon>
                    </template>
                    <span class="white--text">Cancelar</span>
                  </v-tooltip>
                </template>
              </div>
              <div v-else style="width: 24px"><!-- no eliminar --></div>
            </div>
            <div class="d-flex">
              <div
                  v-for="(linea, idxLinea) in area.lineas"
                  :key="`linea-${idxArea}-${idxLinea}`"
                  :class="`${linea.activo ? 'red lighten-2': linea.color} ${(idxLinea < area.lineas.length - 1) && 'mr-3'}`"
                  class="py-3 rounded-lg column-width text-center"
              >
                <div class="px-3">
                  <p
                      class="
                      mb-2
                      white--text
                      text-center text-h6
                      font-weight-medium
                    "
                      style="font-size: 1.125rem !important"
                  >
                    {{ linea.nombre}}
                  </p>
                  <div class="d-flex justify-space-between align-center pb-3" style="min-height: 2.25rem">
                    <div style="width: 24px"><!-- no eliminar --></div>
                    <v-tooltip
                        v-if="getLineaRecursos(linea).length > 0"
                        bottom
                        color="black"
                        class="white--text"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="white"
                        >mdi-robot-industrial-outline
                        </v-icon>
                      </template>
                      <span class="white--text">
                        {{ getLineaRecursosTitulo(linea) }}:
                        <ul>
                          <li v-for="(m, idxM) in getLineaRecursos(linea)" :key="'m'+idxM">{{ m }}</li>
                        </ul>
                      </span>
                    </v-tooltip>
                    <div v-else style="width: 24px"><!-- no eliminar --></div>
                    <div v-if="linea.operaciones.length > 0 && permisoVista('optimizacion','u') && !area.modoEditar">
                      <v-tooltip
                          v-if="!linea.modoEditar"
                          bottom
                          color="black"
                          class="white--text"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="white"
                              @click="setModoEditar(linea,area, fijo)"
                          >mdi-sort
                          </v-icon>
                        </template>
                        <span class="white--text">Ordenar</span>
                      </v-tooltip>
                      <template v-if="!!linea.modoEditar">
                        <v-tooltip
                            v-if="permisoVista('optimizacion','u')"
                            bottom
                            color="black"
                            class="white--text"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="white"
                                :disabled="!!linea.savingOrden"
                                @click="saveNuevoOrden(linea,area)"
                            >mdi-content-save
                            </v-icon>
                          </template>
                          <span class="white--text">Guardar</span>
                        </v-tooltip>
                        <v-tooltip
                            bottom
                            color="black"
                            class="white--text"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="white"
                                :disabled="!!linea.savingOrden"
                                @click="cancelModoEditar(linea,area)"
                            >mdi-cancel
                            </v-icon>
                          </template>
                          <span class="white--text">Cancelar</span>
                        </v-tooltip>
                      </template>
                    </div>
                    <div v-else style="width: 24px"><!-- no eliminar --></div>
                  </div>
                  <v-col v-if="!!linea.savingOrden" cols="12" class="pa-0 pb-2">
                    <v-progress-linear
                        indeterminate
                        color="white"
                    ></v-progress-linear>
                  </v-col>
                </div>

                <div class="px-3 linea-container">
                  <draggable
                      :list="linea.operaciones"
                      :animation="200"
                      ghost-class="ghost-card"
                      class="draggable-area"

                      :disabled="!!linea.savingOrden || !!area.savingOrden || !(area.modoEditar || linea.modoEditar)"

                      :group="area.modoEditar
                        ? { name: `ordenes-${area.idArea}`, pull: true, put: true }      
                        : { name: `solo-${area.idArea}-${linea.idConfiguracionArea}`, pull: true, put: false }"

                      :move="(evt) => canMove(evt, linea, area)"
                    >
                    <OrdenTrabajoCard
                      v-for="operacion in linea.operaciones"
                      :key="operacion.idOperacion"
                      :operacion="operacion"
                      :dependencias="dependencias"
                      :fijo="operacion.fijo"
                      :modoEdicion="(!area.modoEditar || !!linea.savingOrden)"
                      class="mb-3"
                      :style="(operacion.operacionRealEnCurso || !(area.modoEditar || linea.modoEditar) || !!linea.savingOrden)
                        ? 'cursor: default'
                        : 'cursor: grab'"
                      :data-fijo="operacion.fijo"
                      :data-operacion-en-curso="operacion.operacionRealEnCurso"
                      @bloquearEdicion="escucharBloqueoCheckbox(area, operacion)"
                      @change="setDependencias"
                    />
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import OrdenTrabajoCard from "./OptimizacionProduccion/OrdenTrabajoCard.vue";

export default {
  components: {
    draggable,
    OrdenTrabajoCard,
  },
  data() {
    return {
      search: "",
      selectedMolde: null,
      lastAdded: null,
      lastRemoved: null,
      areasProduccion: [],
      moldes: [],
      loading: false,
      dependencias: []
    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    selectedMolde() {
      this.getOptimizacionProduccion();
    }
  },
  computed: {
    filteredMoldes() {
      if (this.moldes?.length === 0) return [];

      if (!this.search) return this.moldes;

      return this.moldes.filter(molde => {
        const term = (this.search || "").toLowerCase();
        const byCodigo = String(molde.codigo || "").toLowerCase().includes(term);
        const byNombre = String(molde.nombre || "").toLowerCase().includes(term);
        const byId = String(molde.idMolde || "") === String(this.search);
        return byCodigo || byNombre || byId;
      });
    }
  },
  methods: {
    canMove(evt, lineaDestino, area) {
      const op = evt.draggedContext?.element;
      if (!op) return false;

      // Nunca mover si está fijo o en curso
      if (op.fijo || op.operacionRealEnCurso) return false;

      const sameList = evt.from === evt.to;

      // Reordenar dentro de la misma línea: permitido SOLO si esa línea está en modo editar o el área está en modo editar
      if (sameList) return !!(lineaDestino.modoEditar || area.modoEditar);

      // Cross-line: SOLO si está editando el área
      if (!area.modoEditar) return false;

      // Validar permiso por idsLineas (si aplica)
      if (Array.isArray(op.idsLineas) && op.idsLineas.length) {
        return op.idsLineas.includes(lineaDestino.idConfiguracionArea);
      }

      return false;
    },
    escucharBloqueoCheckbox(area, operacion) {  //recibe info del componente "OrdenTrabajoCard.vue" pa controlar el bloqueo de cartas
      //console.log("soy la op en el padre: ", operacion.fijo);
      const linea = area.lineas.find(l =>
        l.operaciones.some(op => op.idOperacion === operacion.idOperacion)
      );
      if (!linea) {
        return;
      }
      const index = linea.operaciones.findIndex(op => op.idOperacion === operacion.idOperacion);
      if (index !== -1) {
        this.$set(linea.operaciones[index], 'modoEditar', !operacion.fijo);
      }
    },
   
    // escucharBloqueoCheckbox(operacion) {
    //   console.log("soy la op en el padre: ", operacion)
    //   const linea = this.areasProduccion;
    //   console.log(linea);
    //   linea= this.areasProduccion.find(lineas =>
    //     lineas.lineas.some(l =>
    //       l.operaciones.some(op => op.idOperacion === operacion.idOperacion)
    //     )
    //   ).lineas.find(l => l.operaciones.includes(operacion));

    //   const index = linea.operaciones.findIndex(op => op.idOperacion === operacion.idOperacion);
    //   if (index !== -1) {
    //     this.$set(linea.operaciones[index], 'modoEditar', !operacion.fijo);
    //   }
    // },


    getItemText(item) {
      if (!item) return "";
      const codigo = item.codigo ? String(item.codigo) : "";
      const nombre = item.nombre ? String(item.nombre) : "";
      return `${codigo}${codigo && nombre ? " - " : ""}${nombre}`;
    },
    getLineaRecursos(linea) {
      if (!linea || typeof linea !== "object") return [];
      if (Array.isArray(linea.moldes) && linea.moldes.length > 0) return linea.moldes;
      if (Array.isArray(linea.maquinas) && linea.maquinas.length > 0) return linea.maquinas;
      return [];
    },
    getLineaRecursosTitulo(linea) {
      if (linea && Array.isArray(linea.moldes) && linea.moldes.length > 0) return "Moldes";
      return "Maquinas";
    },
     
    async saveNuevoOrdenArea(area) {
      //console.log("Antes de guardar, área:", JSON.stringify(area, null, 2));
      this.$set(area, 'savingOrden', true);

      const valoresGuardados = await Promise.all(
        area.lineas.map(linea => this.saveNuevoOrden(linea, area))
      );

      if (valoresGuardados.every(value => value)) {
        this.$set(area, 'modoEditar', false);
      }

      this.$set(area, 'savingOrden', false);
      //console.log("Después de guardar área: ", JSON.stringify(area, null, 2));
    }, 
    actualizarLocalmente(operacionesOrdenadas, idConfiguracionArea) {
      const areaAfectada = this.areasProduccion.find(area => area.idConfiguracionArea === idConfiguracionArea);
      if (!areaAfectada) return;

      areaAfectada.lineas.forEach(linea => {
        operacionesOrdenadas.forEach(modificacion => {
          let operacion = linea.operaciones.find(op => op.idOperacion === modificacion.idOperacion);
          if (operacion) {
            operacion.prioridad = modificacion.prioridad;
          }
        });
      });
    },
    cancelModoEditarArea(area) {
      this.$set(area, 'modoEditar', false);
      //console.log("areas antes: ", area);
      area.lineas.forEach(linea => {
        //console.log("antes lineas gene: ", area.lineas);
        //console.log("antes operaciones: ", linea.operaciones);
        this.cancelModoEditar(linea, area);
        //console.log("después cancelar general: ", linea.operaciones);
        //console.log(" después cancelar gene: ", area);
      });
    },

    setModoEditarArea(area) {
      area.lineas.forEach(linea => {
        this.setModoEditar(linea);
        //console.log("Operaciones al darle editar general: ", area.lineas);
      });

      this.$set(area, 'modoEditar', true);
    },
    /**
    * La función `saveNuevoOrden` guarda el nuevo orden de las operaciones dentro de una línea de producción.
    * 
    * - Se establece un estado `savingOrden` en la línea como `true` para indicar que el proceso de guardado está en curso.
    * - Se crea un arreglo `operacionesOrdenadas` donde las operaciones de la línea se invierten y se mapean para incluir el `idOperacion`, `idConfiguracionArea`, `prioridad` (que se asigna según el índice) y el valor de `fijo` de cada operación.
    * - Luego, se realiza una solicitud HTTP `PUT` utilizando Axios para guardar el nuevo orden de operaciones.
    * 
    * El comportamiento es el siguiente:
    * 1. Si la solicitud es exitosa:
    *    - Se actualiza el estado de `savingOrden` en `false`.
    *    - Se desactiva el modo de edición (`modoEditar`).
    *    - Se limpia el antiguo orden de operaciones (`viejoOrden`).
    *    - Si se pasó un área como parámetro, se habilita (`disabled` se establece en `false`).
    * 2. Si la solicitud falla:
    *    - Se actualiza el estado de `savingOrden` en `false`.
    *    - Se muestra el error en la consola.
    * 
    * @param {Object} linea - La línea de producción donde se guardará el nuevo orden.
    * @param {Object|null} area - El área asociada a la línea de producción (opcional).
    * @returns {Promise} - Una promesa que se resuelve en `true` si el proceso es exitoso, o `false` en caso de error.
    */
    saveNuevoOrden(linea, area = null) {
      //console.log("Guardando línea:", JSON.stringify(linea, null, 2));
      return new Promise((resolve) => {
        this.$set(linea, 'savingOrden', true);

        const operacionesOrdenadas = linea.operaciones.map((operacion, index) => ({
          idOperacion: operacion.idOperacion,
          idConfiguracionArea: linea.idConfiguracionArea,
          prioridad: index,
          fijo:operacion.fijo
        }));

        axios
            .put('/OptimizacionProduccion/ModificarPrioridad', operacionesOrdenadas)
            .then( () => {
              this.$set(linea, 'savingOrden', false);
              this.$set(linea, 'modoEditar', false);
              this.$set(linea, 'viejoOrden',  [...linea.operaciones]); 
              if (area) this.$set(area, 'disabled', false);

              this.actualizarLocalmente(operacionesOrdenadas, linea.idConfiguracionArea);
              //const response = await axios.get('/OptimizacionProduccion');
              //console.log("Datos después del PUT:", response.data);
              resolve(true);
            })
            .catch(error => {
              this.$set(linea, 'savingOrden', false);
              console.log(error);

              resolve(false);
            });
      });
    },
    cancelModoEditar(linea, area = null) {
      //console.log("Operaciones antes de copiar: ", linea.operaciones);
      this.$set(linea, 'operaciones', linea.viejoOrden.map(op => ({ ...op })));
      this.$set(linea, 'modoEditar', false);

      //console.log("Viejo Orden después de copiar: ", linea.operaciones);
      if (!area) return;
      if (!area.lineas.some(linea => linea.modoEditar)) {
        this.$set(area, 'disabled', false);
      }
    },
    // setModoEditar(linea, area = null) {
    //   this.$set(linea, 'viejoOrden', linea.operaciones.slice());
    //   this.$set(linea, 'modoEditar', true);
    //   if (area) this.$set(area, 'disabled', true);
    // },
    setModoEditar(linea, area = null) {
      //console.log("Operaciones al darle editar: ", linea.operaciones);
      this.$set(linea, 'viejoOrden', linea.operaciones.map(op => ({ ...op })));
      this.$set(linea, 'modoEditar', true);
      linea.operaciones.forEach(operacion => {
        this.$set(operacion, 'modoEditar', true); // Inicializamos modoEditar en cada operación para controlar bloqueo por "carta" individual.
      });
      if (area) this.$set(area, 'disabled', true);
      //console.log("al area: ", area);
      //console.log("linea oper: ", linea.operaciones);
    },
    revertirUltimoMovimiento() {
      //Eliminamos del arreglo destino el ultimo elemento movido
      const indexLastAdded = this.lastAdded.linea.operaciones.findIndex(
          (operacion) => operacion.idOperacion === this.lastAdded.element.idOperacion
      );

      this.lastAdded.linea.operaciones.splice(indexLastAdded, 1);

      //Agregamos al arreglo origen el ultimo elemento movido
      this.lastRemoved.linea.operaciones.splice(this.lastRemoved.oldIndex, 0, {...this.lastRemoved.element});
    },
    onChangeDraggable(event, linea) {
      const eventKey = Object.keys(event)[0];
      if (eventKey === "added") {
        this.lastAdded = {
          element: event.added.element,
          linea
        }
      } else if (eventKey === "removed") {
        this.lastRemoved = {
          element: event.removed.element,
          oldIndex: event.removed.oldIndex,
          linea
        }
      }

      if (eventKey !== "removed") return;
      //Se valida si el movimiento es valido
      if (!this.lastAdded.element.idsLineas.includes(this.lastAdded.linea.idConfiguracionArea)) {
        this.revertirUltimoMovimiento();
        return;
      }
    },
    getMoldes() {
      this.loading = true;
      axios
          .get("/Moldes")
          .then((response) => {
            if (response.status === 200) {
              this.moldes = response.data;
              this.getOptimizacionProduccion();
            } else {
              this.moldes = [];
              this.loading = false;
            }
          })
          .catch(() => {
            this.moldes = [];
            this.loading = false;
          });
    },
    getOptimizacionProduccion() {
      this.areasProduccion = [];
      this.loading = true;
      const baseUrl = "/OptimizacionProduccion/Moldes";
      const selectedIdMolde = this.selectedMolde && this.selectedMolde.idMolde ? this.selectedMolde.idMolde : null;
      const urlByMolde = selectedIdMolde ? `${baseUrl}?idMolde=${selectedIdMolde}` : baseUrl;

      axios
        .get(urlByMolde)
        .then((response) => {
          this.areasProduccion = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.areasProduccion = [];
          this.loading = false;
        });
    },
    initialize() {
      this.colorIndex = 0;
      this.loading = false;
      this.moldes = [];
      this.getMoldes();
    },
    /**
    * La función `setDependencias` recibe un evento `evt` y actualiza el estado de las dependencias 
    * de las áreas de producción, líneas de producción y operaciones.
    * 
    * - Asigna el valor de `evt` a la propiedad `dependencias` del objeto actual.
    * - Verifica si el evento `evt` está vacío, lo cual influye en la activación o desactivación 
    *   de las áreas y líneas de producción.
    * - Itera sobre cada área de producción y sus líneas de producción, luego verifica las 
    *   operaciones dentro de cada línea.
    * 
    * El comportamiento es el siguiente:
    * 1. Si el evento `evt` está vacío, se desactivan las áreas y líneas de producción.
    * 2. Si el `item` (evento) incluye el `idOperacion` de la operación actual, se activa la 
    *    área y línea de producción correspondiente.
    * 3. Si alguno de los `idsDependientes` de la operación actual está incluido en el `item`, 
    *    también se activa la área y línea de producción.
    * 
    * @param {Object} evt - El evento que contiene los elementos seleccionados para activar o desactivar.
    */
    setDependencias(evt) {
      this.dependencias = evt;
      var item = evt;
      const isItemEmpty = item.length === 0;

      this.areasProduccion.forEach(area => {
        area.lineas.forEach(linea => {
          linea.operaciones.forEach(operacion => {
            if (isItemEmpty) {
              area.activo = false;
              linea.activo = false;
            } else if (item.includes(operacion.idOperacion)) {
              area.activo = true;
              linea.activo = true;
            } else if (operacion.idsDependientes.some(dep => item.includes(dep))) {
              area.activo = true;
              linea.activo = true;
            }
          });
        });
      });
    }
  },
};
</script>
<style scoped>
.linea-container {
  height: calc(100vh - 25rem);
  overflow-y: auto;
  overflow-x: hidden;
}

.draggable-area {
  height: 100%;
}

.column-width {
  min-width: 15.625rem;
  width: 15.625rem;
}

.ghost-card {
  opacity: 0.5;
  background: rgb(247, 247, 247);
  border: 1px solid #546e7a;
}

.autocomplete-input {
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
}
</style>
